module.exports = __webpack_public_path__ + "static/media/img9.74e12101.jpeg";